import FantasyFootballDraft from "./FantasyFootballDraft";
import AdminDashboard from "./AdminDashboard";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";

const isAdmin = window.location.pathname === "/admin";

export default function App() {
  return (
    <>
      {isAdmin ? <AdminDashboard /> : <FantasyFootballDraft />}
      <Analytics />
      <SpeedInsights />
    </>
  );
}